module.exports = __webpack_public_path__ + "img/cns_ios20.891e85d5.png";